export default __webpack_public_path__ + "logo3c4850f.png";